import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { entitiesByIdsFilter } from "../../../../utils/entitiesFiltersUtils";
import { selectEntitiesByFilters } from "../../../../store/views/entityView";
import { getHomeroomClassDisplayString } from "../../../../utils/utils";
import DropDown from "../../dropDown/DropDown";
import entitysType from "../../../../enums/entitysType";
import classes from "./MessageStudyGroupSelect.module.css";

const MessageStudyGroupSelect = ({ studyGroupId, onStudyGroupChange, studyGroups: studyGroups, homeroomClass = false }) => {

    const { texts } = useSelector((state) => state.translate);
    const studyGroupsEntities = useSelector((state) => selectEntitiesByFilters(state, entitiesByIdsFilter(studyGroups, entitysType.studyGroup)));
    const mainClass = useSelector((state) => state.auth.userDetails?.defaultSchool?.mainClasses);
    const mainClassStudyGroups = [...studyGroupsEntities, ...(!homeroomClass ? [] : mainClass)];
    
    if (mainClassStudyGroups?.length <= 1)
        return null;

    return (
        <div className={classes.Wrap}>
            <span className={classes.Label}>{texts.messageStudyGroupLabel}</span>
            <DropDown
                value={getHomeroomClassDisplayString(mainClassStudyGroups.find((g) => String(g.id) === String(studyGroupId)), texts)}
                arrowColor="#333"
                dropClass={classes.DropTrigger}
                dropClassDropDown={classes.DropMenu}
                optionClassName={classes.DropOption}
                options={(mainClassStudyGroups || []).map((g) => ({
                    key: `sg-${g?.id}`,
                    value: getHomeroomClassDisplayString(g, texts),
                    onClick: () => onStudyGroupChange(g?.id),
                }))}
            >
                {texts.messageStudyGroupNone}
            </DropDown>
        </div>
    );
};

export default MessageStudyGroupSelect;
